import { useParams, Navigate } from "react-router-dom";
import { conceptBySlug } from "../data/concepts";
import LayoutServicePro from "../components/concept/LayoutServicePro";
import LayoutEditorialCalm from "../components/concept/LayoutEditorialCalm";
import LayoutPremiumAuthority from "../components/concept/LayoutPremiumAuthority";
import LayoutPortfolio from "../components/concept/LayoutPortfolio";
import LayoutModernTech from "../components/concept/LayoutModernTech";
import LayoutEmergencyAction from "../components/concept/LayoutEmergencyAction";

const LAYOUTS = {
  "service-pro":       LayoutServicePro,
  "editorial-calm":    LayoutEditorialCalm,
  "premium-authority": LayoutPremiumAuthority,
  "portfolio":         LayoutPortfolio,
  "modern-tech":       LayoutModernTech,
  "emergency-action":  LayoutEmergencyAction,
};

export default function ConceptPreview() {
  const { slug } = useParams();
  const c = conceptBySlug(slug);
  if (!c) return <Navigate to="/" replace />;

  const Layout = LAYOUTS[c.layout] || LayoutServicePro;
  return <Layout c={c} />;
}
